import React from 'react'
import { APIClient } from '@/services'
import { assignTextStyle, useI18N } from '@codeleap/common'
import { useNavigation } from '../Navigation'
import { View, Link, Button, Icon } from '@/components'
import { navigate } from 'gatsby'
import { variantProvider } from '@/app'
import { usePageContext } from '@/utils'
import { TypeGuards } from '@codeleap/types'

export const BASE_SITE_URL = 'https://hurd.world/'

const navItems = [
  {
    name: 'Home',
    url: 'feed/'
  },
  {
    name: 'Learn',
    url: 'learn/'
  },
  {
    name: 'Scores',
    url: 'scores/'
  },
  {
    name: 'About',
    url: BASE_SITE_URL + 'about/'
  },
  // {
  //   name: 'Act',
  //   url: 'act/',
  // },

  // {
  //   name: 'Community',
  //   url: 'community/',
  // },
  {
    name: 'For Employers',
    url: BASE_SITE_URL + 'for-employers/'
  },
  {
    name: 'Blog',
    url: BASE_SITE_URL + 'blog/'
  }
]

export const BREAKPOINT = 'mid'

export const HeaderItems = ({ variantStyles }) => {
  const { isLoggedIn } = APIClient.Session.useAuthState()
  const { matchPath } = useNavigation()
  const { t } = useI18N()

  const renderItem = React.useCallback(item => {
    const isSelected = matchPath(item?.url)
    const isExternal = item?.url?.startsWith('http')
    const hasOnPress = TypeGuards.isFunction(item?.onPress)

    const handleClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
      if (hasOnPress) {
        event.preventDefault()
        item?.onPress?.()
      }
    }

    return (
      <View key={item?.url + 'header'} variants={['row', 'relative', 'alignStart', 'center']}>
        <Link
          tabIndex={0}
          to={hasOnPress ? '' : isExternal ? item?.url : '/' + item?.url}
          onClick={handleClick}
          variants={['noUnderline']}
          css={[variantStyles.navItem, isSelected ? variantStyles['navItem:selected'] : {}]}
        >
          {t(`links.${item?.name}`)}

          {/* specific to match clients header */}
          {item?.name === 'About' ? (
            <div
              style={{
                marginLeft: 5,
                width: 14,
                height: 14,
                position: 'relative'
              }}
            >
              <Icon debugName="" name="chevron-down" size={16} variants={['absolute', 'whole']} />
            </div>
          ) : null}
        </Link>
      </View>
    )
  }, [])

  const goToMyProfile = () => {
    const path = isLoggedIn ? '/profile/edit/' : '/auth/signup/'

    navigate(path)
  }

  const ctx = usePageContext()

  return (
    <View
      variants={['gap:4', 'center']}
      responsiveVariants={{
        [BREAKPOINT]: ['column', 'gap:2', 'alignCenter', 'paddingBottom:2']
      }}
    >
      <View variants={['fullWidth']} responsiveVariants={{ [BREAKPOINT]: ['column'] }} component="nav">
        {navItems.map(renderItem)}
      </View>

      <Button
        text={ctx?.myProfileButton ?? t('header.myProfile')}
        css={variantStyles.navButton}
        variants={['circle', 'large']}
        styles={{
          text: styles.text,
          wrapper: styles.wrapper
        }}
        responsiveVariants={{ [BREAKPOINT]: ['large'] }}
        onPress={goToMyProfile}
        debugName="header signIn"
      />
    </View>
  )
}

const styles = variantProvider.createComponentStyle(
  theme => ({
    text: {
      ...assignTextStyle('h4')(theme).text,
      fontWeight: '400',
      letterSpacing: 0
    },
    wrapper: {
      '&:hover': {
        backgroundColor: theme.colors.neutral10
      }
    }
  }),
  true
)
